import { ADMIN, COMMON, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

interface IProps {
  promotionId: string | number;
  rows?: Array<string>;
  promotion_no: string | number;
  langList: Array<string>;
}
interface IInputData {
  promotion_no: number | string;
  title: string;
  is_public: string;
  start_date: string;
  end_date: string;
  promotion_type: string;
  location: string;
  os: string;
  exception_culture?: string;
}

interface INewProp {
  key: number | undefined;
  text: string | number | undefined;
  value: string | number | undefined;
}

export const promotionApis = {
  read: () =>
    ifyouApi
      .get(`${ADMIN}/promotion-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  detail: (promotionId: IProps) =>
    ifyouApi
      .get(`${ADMIN}/${promotionId}/promotion-detail`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  // 등록 & 수정 : 등록일 경우, promotion_no=0
  update: (inputData: IInputData, langData: IProps) =>
    ifyouApi
      .post(`${ADMIN}/promotion-update`, {
        promotion_no: inputData.promotion_no,
        title: inputData.title,
        is_public: inputData.is_public,
        start_date: inputData.start_date,
        end_date: inputData.end_date,
        promotion_type: inputData.promotion_type,
        location: inputData.location,
        os: inputData.os,
        exception_culture: inputData.exception_culture,
        langList: langData,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  delete: (promotionId: IProps) =>
    ifyouApi
      .post(`${ADMIN}/promotion-delete`, {
        promotion_no: promotionId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  sorting: (rows: IProps) =>
    ifyouApi
      .post(`${ADMIN}/promotion-sorting`, {
        rows: rows,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};

interface IValue {
  project_id?: number | string | undefined;
  title?: string | undefined;
  code?: string | undefined;
  code_name?: string | undefined;
  country_code?: string;
  country_name?: string;
  notice_no?: string | number;
  notice_name?: string;
}
export const fetchPromotionDropApis = {
  promotion_location: () =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'standard',
        code: 'promotion_location',
      })
      .then((res) => {
        const newData: INewProp[] = [];
        res.data?.map((v: IValue, i: number) =>
          newData.push({ key: i, text: v.code_name, value: v.code }),
        );
        return newData;
      })
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  promotion_banner_list: () =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'promotionList',
        code: 'promotion_banner',
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  notice_list: () =>
    ifyouApi
      .post(`${COMMON}`, { func: 'getNoticeDropDown' })
      .then((res) => {
        const newData: INewProp[] = [];
        res.data?.map((v: IValue, i: number) =>
          newData.push({
            key: i,
            text: v.notice_name,
            value: String(v.notice_no),
          }),
        );
        return newData;
      })
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
